<template>
    <el-dialog :visible.sync="lableShow" width="738px" :show-close="false" @close="close" center
        :close-on-press-escape="false" :close-on-click-modal="false">
        <div class="lable_popup">
            <div class="lable_title">
                作品风格（可多选）
                <i class="el-icon-close cursor_1" @click="lableShow = false"></i>
            </div>
            <div class="lable_popup1" ref="scrollContainer">
                <div class="lable_popup1_1">
                    <div class="lable_popup1_3">
                        <div class="cursor_1" :ref="(el) => lableTop[i] = el"
                            :class="lable.select ? 'lable_popup200 lable_popup3' : 'lable_popup200'"
                            v-for="(lable, i) in lableList" :key="i" @click="select(i)">
                            {{ lable.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="lable_popup4">
                <el-input v-model="input" maxlength="200" show-word-limit placeholder="请输入自定义风格"></el-input>
            </div>
            <div class="lable_popup5">
                <div class="lable_popup6">{{ selectLen }}/10</div>
                <el-button class="lable_popup7" type="warning" :loading="loading"
                    @click="confirm"><span>确认</span></el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import api from '@/api/api';
import _ from 'lodash'
export default {
    data() {
        return {
            lableShow: false, //标签选择弹框显示
            lableList: [], //所有标签
            lableI: [], //选中标签
            customizeL: [], //自定义标签
            lableTop: [],
            input: '',//自定义内容
            isScrolling: false, //是否滚动
            loading: false,
        }
    },
    watch: {
        input(newVal) {
            if (newVal) {
                let len = this.lableI.length;
                if (len >= 10) {
                    this.input = ''
                    this.$message.warning('无法自定义风格，已选十个标签')
                    return
                }
            }
        }
    },
    computed: {
        selectLen() {
            return this.sumSelectedLen();
        }
    },
    methods: {
        openLable(data) {
            // console.log(data)
            this.getLable()
            setTimeout(() => {
                if (this.lableList.length) {
                    // 先清空之前的选择
                    this.lableI = [];

                    // 更新labelList并同步收集选中的项
                    this.lableList = this.lableList.map(item => {
                        const matched = data.find(val => val === item.name);
                        if (matched) {
                            this.lableI.push(matched); // 推送匹配的原始数据
                            return { ...item, select: true };
                        }
                        return { ...item, select: false };
                    });
                    data.forEach(item=>{
                        if(!this.lableI.includes(item)){
                            this.input = item
                        }
                    })

                    //初始化跳转选中的第一个按钮位置
                    this.lableList.some((item, index) => {
                        if (item.select) {
                            this.changeTitle(index);
                            return true; // 终止循环
                        }
                        return false; // 继续遍历
                    });
                }
            }, 100)
            this.lableShow = true
        },
        // 指定第一个选中的区域
        changeTitle(i) {
            const scrollContainer = this.$refs.scrollContainer;
            const lable = this.getOffsetTop(i);
            if (lable) {
                scrollContainer.scrollTo({
                    top: lable - scrollContainer.offsetTop,
                    behavior: "smooth",
                });
            }
        },
        // 安全访问方法
        getOffsetTop(index) {
            if (this.lableTop[index]) {
                return this.lableTop[index].offsetTop;
            }
            return 0;
        },
        // 获取标签
        getLable() {
            api.tags({writerType:'label',paramKey:'storyLabel'}).then((res) => {
                if (res.code == 200) {
                    this.lableList = res.data.split(',').map((label) => ({
                        select: false,
                        name: label,
                        key: 'label'
                    }))
                }
            })
        },
        // 计算选中总长度
        sumSelectedLen() {
            this.input = this.convertCommas(this.input)
            return this.lableI.length + (this.input ? 1 : 0);
        },
        // 选择标签
        select(i) {
            let selectLen = this.sumSelectedLen();
            this.lableList.forEach((item, index) => {
                if (i === index) {
                    if (selectLen === 10) {
                        if (item.select) {
                            item.select = false
                            return
                        }
                        this.$message.warning('最多选十个标签');
                        return
                    }
                    item.select = !item.select
                }
            })
            //更新最新已经选中的
            let selectedLabel = this.lableList.filter(item => item.select).map(m=>m.name)
            this.lableI = selectedLabel;
        },
        // 确认
        confirm() {
            let len = this.sumSelectedLen();
            if (len > 10) {
                this.$message.warning('最多选十个标签');
                return
            }
            this.loading = true
            let a = _.cloneDeep(this.lableI);
            if (this.input) {
                a = a.concat(this.input)
            }
            // console.log('提交=', a)
            this.$emit('getLable', a)
            this.close()
        },
        // 关闭
        close() {
            this.lableShow = false
            this.lableI = []
            this.input = ''
            this.loading = false
        },
        handleScroll() {
            const scrollContainer = this.$refs.scrollContainer;
            const currentScrollTop = scrollContainer.scrollTop;
            this.lableTop.map((item, i) => {
                if (currentScrollTop + 147 >= item) {
                    if (this.isScrolling) {
                        this.lableTitleI = i
                    }

                }
            });
        }

    }
}
</script>

<style>
#novel_create .el-dialog__header,
#novel_create .el-dialog__header {
    padding: 0;
}

#novel_create .el-dialog__body,
#novel_create .el-dialog__body {
    padding: 0;
    background-color: transparent !important;
}

#novel_create .el-dialog,
#novel_create .el-dialog {
    background-color: transparent !important;
    box-shadow: none;
}

.cursor_1:hover {
    opacity: 0.8;
}

.lable_popup {
    width: 738px;
    padding-bottom: 20px;
    border-radius: 12px;
    background-color: #FFFFFF;
    overflow: hidden;
    position: relative;
}

.lable_title {
    width: 100%;
    height: 75px;
    font-size: 19px;
    color: #111111;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #F5F7FA;
    padding: 0 42px;
}

.lable_popup1 {
    width: 738px;
    max-height: 200px;
    padding: 0 40px;
    margin: 20px 0 5px 0;
    overflow: auto;
    -ms-overflow-style: none;
    /* IE和Edge浏览器下隐藏滚动条 */
    scrollbar-width: none;
    /* Firefox下隐藏滚动条 */
}

.lable_popup1_2 {
    margin-bottom: 13px;
}

.lable_popup1_3 {
    display: flex;
    flex-flow: wrap;
}



.lable_popup3 {
    border: 1px solid var(--tech-primary);
    color: var(--tech-primary);
}

.lable_popup4 {
    width: 738px;
    padding: 0 40px;
}

.lable_popup5 {
    width: 738px;
    padding: 0 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
}

.lable_popup6 {
    font-size: 13px;
    color: #333333;
    font-weight: 400;
}

.lable_popup7 {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--tech-primary);
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 400;
    border-radius: 8px;
}

.lable_popup8 {
    width: 738px;
    overflow-x: scroll;
    white-space: nowrap;
    -ms-overflow-style: none;
    /* IE和Edge浏览器下隐藏滚动条 */
    scrollbar-width: none;
    /* Firefox下隐藏滚动条 */
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 0px;
    border-bottom: 1px solid #EBEFF4;
}

.lable_popup8_1 {
    font-weight: 400;
    font-size: 17px;
    color: #666666;
    margin-right: 33px;
    position: relative;
}

.lable_popup8_2 {
    color: #111111;
    font-weight: bold;
}

.lable_popup8_3 {
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translate(-50%);
    width: 17px;
    height: 4px;
    background: #FF6603;
    border-radius: 0px 0px 0px 0px;
}
</style>